import React, { useState, useRef, useEffect } from "react";
import { getApi, postApi } from "../../../Services/apiService";
import { Button } from "react-bootstrap";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  Autocomplete,
} from "@react-google-maps/api";
import { Multiselect } from "multiselect-react-dropdown";

const AddVenueModal = ({ setAddVenueModal, fetchVenues }) => {

  // Add these refs with your other useRef declarations
const nameRef = useRef(null);
const websiteRef = useRef(null);
const phoneRef = useRef(null);
const emailRef = useRef(null);
const wishlistRef = useRef(null);
const locationRef = useRef(null);
const pincodeRef = useRef(null);
const shortDescRef = useRef(null);
const descRef = useRef(null);
const bannerImageRef = useRef(null);
const imagesRef = useRef(null);
const priceRangeRef = useRef(null);
const typeRef = useRef(null);


  const [loader, setLoader] = useState(false);
  const [price, setPrice] = useState("$$$");
  const [formData, setFormData] = useState({
    name: "",
    website_link: "",
    phone_number: "",
    email: "",
    wishlist_booking_url: "",
    category_type: [],
    price_range: "3",
    type: "",
    latitude: "",
    longitude: "",
    location: "",
    pincode: "",
    short_desc: "",
    description: "",
    banner_image: null,        // User-uploaded banner
    api_banner_image: null,    // API-provided banner
    images: [],                // User-uploaded images
    api_images: [],            // API-provided images
    dishes: [],
    country: "",
    city: ""
  });
  const [filePreviews, setFilePreviews] = useState({
    banner_image: null,
    api_banner_image: null,
    images: [],
    api_images: [],
  });
  const [errors, setErrors] = useState({});
  const [mapCenter, setMapCenter] = useState({
    lat: 40.73061,
    lng: -73.935242,
  });
  const [markerPosition, setMarkerPosition] = useState(null);
  const autocompleteRef = useRef(null);
  const [placeId, setPlaceId] = useState(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAdn5bqjKHkbI5qkM2VJre9POdgo513Hxg",
    libraries: ["places"],
  });

  // Price level mapping
  const priceLevelMapping = {
    0: "$",    // Free
    1: "$",    // Inexpensive
    2: "$$",   // Moderate
    3: "$$$",  // Expensive
    4: "$$$$", // Very Expensive
  };

  // Reverse mapping for form submission
  const priceRangeMapping = {
    "$": 1,
    "$$": 2,
    "$$$": 3,
    "$$$$": 4,
    "$$$$$": 5,
  };

  // Type mapping
  const typeMapping = {
    "restaurant": "1",
    "bar": "2",
    "night_club": "3",
    "tourist_attraction": "4",
    "lodging": "5"
  };

  // Fetch place details when placeId changes
  useEffect(() => {
    if (placeId && isLoaded) {
      fetchPlaceDetails(placeId);
    }
  }, [placeId, isLoaded]);

  const fetchPlaceDetails = async (placeId) => {
    try {
      const response = await getApi(`/admin/place-details?place_id=${placeId}`);
      
      if (response.status === 200 && response.data) {
        const place = response.data.result;
        
        // Determine price range and symbol
        let priceRangeValue = "3";
        let priceSymbol = "$$$";
  
        if (place.hasOwnProperty("price_level") && place.price_level !== null) {
          const symbol = priceLevelMapping[place.price_level];
          priceRangeValue = priceRangeMapping[symbol] || "";
          priceSymbol = symbol || "";
        }
  
        // Handle photos from Google Places API
        let bannerImageUrl = null;
        let additionalImages = [];
        const limitedPhotos = place.photos.slice(0, 2);
        if (place.photos && place.photos.length > 0) {
          bannerImageUrl = `https://maps.googleapis.com/maps/api/place/photo?maxwidth=800&photoreference=${place.photos[0].photo_reference}&key=AIzaSyAdn5bqjKHkbI5qkM2VJre9POdgo513Hxg`;
          additionalImages =  limitedPhotos.map((photo) =>
            `https://maps.googleapis.com/maps/api/place/photo?maxwidth=800&photoreference=${photo.photo_reference}&key=AIzaSyAdn5bqjKHkbI5qkM2VJre9POdgo513Hxg`
          );
        }
  
        // Update form data
        const updatedData = {
          ...formData,
          name: place.name || "",
          website_link: place.website || "",
          phone_number: place.formatted_phone_number || "",
          price_range: priceRangeValue,
          type: place.types
            ? place.types.map((t) => typeMapping[t]).find((t) => t) || ""
            : "",
          category_type: place.types || [],
          api_banner_image: bannerImageUrl,
          api_images: additionalImages
        };
  
        setFormData(updatedData);
        setPrice(priceSymbol);
  
        // Update previews
        setFilePreviews({
          ...filePreviews,
          api_banner_image: bannerImageUrl,
          api_images: additionalImages
        });
      }
    } catch (error) {
      console.error("Error fetching place details:", error);
    }
  };
  
  const handlePriceRangeChange = (priceSymbol) => {
    const priceValue = priceRangeMapping[priceSymbol];
    setFormData({ ...formData, price_range: priceValue });
    setPrice(priceSymbol);
    if (errors.price_range) {
      setErrors({ ...errors, price_range: "" });
    }
  };

  const urlToFile = async (url, filename) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const mimeType = blob.type || 'image/jpeg'; // fallback just in case
      return new File([blob], filename, { type: mimeType });
    } catch (err) {
      console.error("Error converting URL to file:", err);
      return null;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "banner_image") {
      const file = files[0];
      setFormData(prev => ({ ...prev, banner_image: file }));
      setFilePreviews(prev => ({
        ...prev,
        banner_image: URL.createObjectURL(file),
      }));
      if (errors.banner_image) {
        setErrors({ ...errors, banner_image: "" });
      }
    } else if (name === "images") {
      const filesArray = Array.from(files);
      setFormData(prev => ({ ...prev, images: [...prev.images, ...filesArray] }));
      const previewsArray = filesArray.map((file) => URL.createObjectURL(file));
      setFilePreviews(prev => ({ ...prev, images: [...prev.images, ...previewsArray] }));
      if (errors.images) {
        setErrors({ ...errors, images: "" });
      }
    }
  };

  const handleRemoveFile = (type, index) => {
    if (type === "banner_image") {
      setFormData(prev => ({ ...prev, banner_image: null }));
      setFilePreviews(prev => ({ ...prev, banner_image: null }));
      setErrors(prev => ({ ...prev, banner_image: "Banner image is required." }));
    } 
    else if (type === "api_banner_image") {
      setFormData(prev => ({ ...prev, api_banner_image: null }));
      setFilePreviews(prev => ({ ...prev, api_banner_image: null }));
    }
    else if (type === "images") {
      const updatedImages = [...formData.images];
      updatedImages.splice(index, 1);
      setFormData(prev => ({ ...prev, images: updatedImages }));

      const updatedPreviews = [...filePreviews.images];
      updatedPreviews.splice(index, 1);
      setFilePreviews(prev => ({ ...prev, images: updatedPreviews }));
      
      if (updatedImages.length === 0 && formData.api_images.length === 0) {
        setErrors(prev => ({ ...prev, images: "At least one image is required." }));
      }
    }
    else if (type === "api_images") {
      const updatedImages = [...formData.api_images];
      updatedImages.splice(index, 1);
      setFormData(prev => ({ ...prev, api_images: updatedImages }));

      const updatedPreviews = [...filePreviews.api_images];
      updatedPreviews.splice(index, 1);
      setFilePreviews(prev => ({ ...prev, api_images: updatedPreviews }));
      
      if (updatedImages.length === 0 && formData.images.length === 0) {
        setErrors(prev => ({ ...prev, images: "At least one image is required." }));
      }
    }
  };

  const validateForm = () => {
    let validationErrors = {};
    let firstErrorField = null;
  
    // Name validation
    if (!formData.name.trim()) {
      validationErrors.name = "Name is required.";
      if (!firstErrorField) firstErrorField = "name";
    }
  
    // Description validation
    if (formData.description && formData.description.trim() !== "") {
      if (formData.description.trim().length < 2 || formData.description.trim().length > 500) {
        validationErrors.description = "Description must be between 2 and 500 characters.";
        if (!firstErrorField) firstErrorField = "description";
      }
    }
    
    // Short description validation
    if (formData.short_desc && formData.short_desc.trim() !== "") {
      if (formData.short_desc.trim().length < 2 || formData.short_desc.trim().length > 250) {
        validationErrors.short_desc = "Short description must be between 2 and 250 characters.";
        if (!firstErrorField) firstErrorField = "short_desc";
      }
    }
  
    // Wishlist URL validation
    if (formData.wishlist_booking_url?.trim()) {
      const urlPattern = /^https?:\/\/[^\s$.?#].[^\s]*$/;
      if (!urlPattern.test(formData.wishlist_booking_url.trim())) {
        validationErrors.wishlist_booking_url = "Enter a valid URL starting with http:// or https://";
        if (!firstErrorField) firstErrorField = "wishlist_booking_url";
      }
    }
   
    // Website URL validation
    if (formData.website_link?.trim()) {
      const urlPattern = /^https?:\/\/[^\s$.?#].[^\s]*$/;
      if (!urlPattern.test(formData.website_link.trim())) {
        validationErrors.website_link = "Enter a valid URL starting with http:// or https://";
        if (!firstErrorField) firstErrorField = "website_link";
      }
    }
  
    // Banner image validation
    if (!formData.banner_image && !formData.api_banner_image) {
      validationErrors.banner_image = "Banner image is required.";
      if (!firstErrorField) firstErrorField = "banner_image";
    }
  
    // Images validation
    if (formData.images.length === 0 && formData.api_images.length === 0) {
      validationErrors.images = "At least one image is required.";
      if (!firstErrorField) firstErrorField = "images";
    }
  
    // Type validation
    if (!formData.type.trim()) {
      validationErrors.type = "Type is required.";
      if (!firstErrorField) firstErrorField = "type";
    }
  
    // Price range validation
    if (!formData.price_range) {
      validationErrors.price_range = "Price Range is required.";
      if (!firstErrorField) firstErrorField = "price_range";
    }
  
    // Category type validation
    if (!formData.category_type) {
      validationErrors.category_type = "Category Type is required.";
      if (!firstErrorField) firstErrorField = "category_type";
    } else if (typeof formData.category_type === "string") {
      const regex = /^([a-zA-Z_-]+)(,[a-zA-Z_-]+)*$/;
      if (!regex.test(formData.category_type)) {
        validationErrors.category_type = "Invalid format. Use comma-separated words like bar,cafe.";
        if (!firstErrorField) firstErrorField = "category_type";
      }
    }
  
    // Location validation
    if (!formData.location) {
      validationErrors.location = "Location is required.";
      if (!firstErrorField) firstErrorField = "location";
    }
  
    setErrors(validationErrors);
    return {
      isValid: Object.keys(validationErrors).length === 0,
      firstErrorField
    };
  };

  const scrollToError = (fieldName) => {
    let elementToScroll = null;
    
    switch(fieldName) {
      case 'name': elementToScroll = nameRef.current; break;
      case 'website_link': elementToScroll = websiteRef.current; break;
      case 'phone_number': elementToScroll = phoneRef.current; break;
      case 'email': elementToScroll = emailRef.current; break;
      case 'wishlist_booking_url': elementToScroll = wishlistRef.current; break;
      case 'location': elementToScroll = locationRef.current; break;
      case 'pincode': elementToScroll = pincodeRef.current; break;
      case 'short_desc': elementToScroll = shortDescRef.current; break;
      case 'description': elementToScroll = descRef.current; break;
      case 'banner_image': elementToScroll = bannerImageRef.current; break;
      case 'images': elementToScroll = imagesRef.current; break;
      case 'price_range': elementToScroll = priceRangeRef.current; break;
      case 'type': elementToScroll = typeRef.current; break;
    }
    
    if (elementToScroll) {
      const modalBody = document.querySelector('.scrollable-modal-body');
      const elementRect = elementToScroll.getBoundingClientRect();
      const modalBodyRect = modalBody.getBoundingClientRect();
      const scrollPosition = elementRect.top - modalBodyRect.top + modalBody.scrollTop - 20;
      
      modalBody.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
      
      setTimeout(() => {
        const inputElement = elementToScroll.querySelector('input, textarea, select');
        if (inputElement) {
          inputElement.focus();
        }
      }, 500);
    }
  };
  const handleSubmit = async () => {

    const { isValid, firstErrorField } = validateForm();
  
  if (!isValid) {
    if (firstErrorField) {
      scrollToError(firstErrorField);
    }
    return;
  }
    if (!validateForm()) return;
  
    setLoader(true);
    const formDataToSend = new FormData();
  
    // Handle banner image - user uploaded file takes precedence
    if (formData.banner_image) {
      formDataToSend.append("banner_image", formData.banner_image);
    } else if (formData.api_banner_image) {
      // Send API banner URL as string
      formDataToSend.append("api_banner_image_url", formData.api_banner_image);
    }
  
    // Handle additional images
    // 1. Add API image URLs as strings
    formData.api_images.forEach((url, index) => {
      formDataToSend.append(`api_image_urls[${index}]`, url);
    });
  
    // 2. Add user-uploaded image files
    formData.images.forEach((file, index) => {
      formDataToSend.append(`images`, file);
    });
  
    // Add all other form data
    Object.keys(formData).forEach((key) => {
      if (
        key !== "banner_image" &&
        key !== "api_banner_image" &&
        key !== "images" &&
        key !== "api_images"
      ) {
        if (key === "category_type") {
          const categoryType = formData[key];
    
          if (Array.isArray(categoryType)) {
            categoryType.forEach((value, index) => {
              formDataToSend.append(`category_type[${index}]`, value);
            });
          } else if (typeof categoryType === "string") {
            // Split string on comma and trim spaces
            const types = categoryType
              .split(',')
              .map((item) => item.trim())
              .filter(Boolean);
            types.forEach((value, index) => {
              formDataToSend.append(`category_type[${index}]`, value);
            });
          } else {
            formDataToSend.append("category_type[0]", categoryType);
          }
        } else {
          formDataToSend.append(key, formData[key]);
        }
      }
    });
    
  
    try {
      const response = await postApi("/admin/category", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      if (response.status === 200) {
        setAddVenueModal(false);
        fetchVenues();
      }
    } catch (error) {
      console.error("Error adding venue:", error);
      // Show error message to user if needed
    } finally {
      setLoader(false);
    }
  };
  const onPlaceChanged = () => {
    if (!autocompleteRef.current) return;
  
    const place = autocompleteRef.current.getPlace();
  
    if (place && place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      let fullAddress = place.formatted_address || "";
      let pincode = "";
      let country = "";
      let city = "";
  
      if (place.address_components) {
        place.address_components.forEach((component) => {
          if (component.types.includes("postal_code")) {
            pincode = component.long_name;
          }
          if (component.types.includes("country")) {
            country = component.long_name;
          }
          if (component.types.includes("locality")) {
            city = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            city = component.long_name;
          }
        });
      }
  
      setMapCenter({ lat, lng });
      setMarkerPosition({ lat, lng });
      setPlaceId(place.place_id);
  
      setFormData((prevData) => ({
        ...prevData,
        latitude: lat.toString(),
        longitude: lng.toString(),
        location: fullAddress,
        pincode: pincode || "",
        place_id: place.place_id,
        country,
        city,
      }));
    }
  };
  
  
  const onMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setMarkerPosition({ lat, lng });

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const address = results[0].formatted_address;
        let pincode = "";
        let placeId = results[0].place_id || "";
        let country = "";
        let city = "";

        results[0].address_components.forEach((component) => {
          if (component.types.includes("postal_code")) {
            pincode = component.long_name;
          }
          if (component.types.includes("country")) {
            country = component.long_name;
          }
          if (component.types.includes("locality")) {
            city = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            city = component.long_name;
          }
        });

        setFormData((prevData) => ({
          ...prevData,
          latitude: lat.toString(),
          longitude: lng.toString(),
          location: address,
          pincode: pincode || "",
          place_id: placeId,
          country,
          city,
          name: "",             // 👈 reset optional fields
          website_link: "",

          phone_number: "",
        }));
        setPlaceId(placeId); // Update placeId based on geocoding
        setMapCenter({ lat, lng }); // Update map center to the clicked location
      } else {
        console.error("Geocoder failed due to:", status);
        setFormData((prevData) => ({
          ...prevData,
          latitude: lat.toString(),
          longitude: lng.toString(),
        }));
      }
    });
  };

  const onMarkerDragEnd = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setMarkerPosition({ lat, lng });
    setMapCenter({ lat, lng }); // Update map center to the dragged position

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const address = results[0].formatted_address;
        let pincode = "";
        let placeId = results[0].place_id || "";
        let country = "";
        let city = "";

        results[0].address_components.forEach((component) => {
          if (component.types.includes("postal_code")) {
            pincode = component.long_name;
          }
          if (component.types.includes("country")) {
            country = component.long_name;
          }
          if (component.types.includes("locality")) {
            city = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            city = component.long_name;
          }
        });
        setFormData((prevData) => ({
          ...prevData,
          latitude: lat.toString(),
          longitude: lng.toString(),
          location: address,
          pincode: pincode || "",
          place_id: placeId,
          country,
          city,
          name: "",             // 👈 reset optional fields
          website_link: "",

          phone_number: "",
        }));
        setPlaceId(placeId); // Update placeId based on geocoding
      } else {
        console.error("Geocoder failed due to:", status);
        setFormData({
          ...formData,
          latitude: lat.toString(),
          longitude: lng.toString(),
        });
      }
    });
  };
 

  return (
    <div className="detail-page-modal">
      <div className="modal-header">
        <h3>Add Venue</h3>
        <button
          className="close-button"
          onClick={() => setAddVenueModal(false)}
        >
          <img
            src={window.getPublicUrl("/assets/images/Close_round_light.svg")}
            alt="close"
          />
        </button>
      </div>
      <div className="modal-body scrollable-modal-body">
  <div className="input-main">
    <div className="row">
      {/* Location Field */}
      <div className="col-sm-12" ref={locationRef}>
        <div className="custom-floating-group">
          {isLoaded && (
            <Autocomplete
              onLoad={(autocomplete) =>
                (autocompleteRef.current = autocomplete)
              }
              onPlaceChanged={onPlaceChanged}
            >
              <input
                type="text"
                placeholder="Enter location"
                className="form-control"
                value={formData.location}
                onChange={(e) =>
                  setFormData({ ...formData, location: e.target.value })
                }
              />
            </Autocomplete>
          )}
          {errors.location && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.location}
            </span>
          )}
        </div>
      </div>
      
      {/* Map - Doesn't need a ref as it's not an input field */}
      <div className="col-sm-12 mb-4">
        {isLoaded && (
          <GoogleMap
            mapContainerStyle={{ height: "400px", width: "100%" }}
            zoom={12}
            center={mapCenter}
            onClick={onMapClick}
          >
            {markerPosition && (
              <Marker
                position={markerPosition}
                draggable={true}
                onDragEnd={onMarkerDragEnd}
              />
            )}
          </GoogleMap>
        )}
      </div>

      {/* Dynamic Input Fields */}
      {Object.keys(formData).map((key) =>
        key !== "images" &&
        key !== "banner_image" &&
        key !== "dishes" &&
        key !== "place_id" &&
        key !== "location" &&
        key !== "latitude" &&
        key !== "longitude" &&
        key !== "pincode" &&
        key !== "price_range" &&
        key !== "type" &&
        key !== "city" &&
        key !== "country" &&
        key !== "api_banner_image" &&
        key !== "api_images" 
       ? (
          <div className="col-sm-6" key={key} ref={
            key === 'name' ? nameRef :
            key === 'website_link' ? websiteRef :
            key === 'phone_number' ? phoneRef :
            key === 'email' ? emailRef :
            key === 'wishlist_booking_url' ? wishlistRef :
            key === 'short_desc' ? shortDescRef :
            key === 'description' ? descRef : null
          }>
            <div className="custom-floating-group">
              <input
                type={key.includes("email") ? "email" : "text"}
                name={key}
                placeholder=" "
                value={formData[key]}
                onChange={handleChange}
                className={errors[key] ? 'error' : ''}
              />
              <label>{key.replace("_", " ")}</label>
              {errors[key] && (
                <span style={{ color: "red", fontSize: "14px" }}>
                  {errors[key]}
                </span>
              )}
            </div>
          </div>
        ) : null
      )}

      {/* Price Range Field */}
      <div className="col-sm-6" ref={priceRangeRef}>
        <div className="custom-floating-group price-range">
          <label>Price Range</label>
          <div className="tabs">
            {["$", "$$", "$$$", "$$$$", "$$$$$"].map(
              (priceOption, index) => (
                <button
                  key={index}
                  type="button"
                  className={`price-tab ${
                    price == priceOption ? "active" : ""
                  }`}
                  onClick={() => handlePriceRangeChange(priceOption)}
                >
                  {priceOption}
                </button>
              )
            )}
          </div>
          {errors.price_range && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.price_range}
            </span>
          )}
        </div>
      </div>

      {/* Type Field */}
      <div className="col-sm-6" ref={typeRef}>
        <div className="custom-floating-group">
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            className={errors.type ? 'error' : ''}
          >
            <option value="">Select Venue Type</option>
            <option value="1">Restaurant</option>
            <option value="2">Bar</option>
            <option value="3">Club</option>
            <option value="4">City Attraction</option>
            <option value="5">Hostel</option>
            <option value="6">Experience</option>
          </select>
          <label>Type</label>
          {errors.type && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.type}
            </span>
          )}
        </div>
      </div>

      {/* Banner Image Field */}
      <div className="col-sm-6" ref={bannerImageRef}>
        <div className="upload-wrapper">
          <input
            type="file"
            id="bannerImage"
            name="banner_image"
            className="upload-input"
            onChange={handleFileChange}
          />
          <label htmlFor="bannerImage" className="upload-label">
            <img
              className="upload-icon"
              src={window.getPublicUrl("/assets/images/upload.svg")}
              alt=""
            />
            banner image
            <div className="upload-box">
              {errors.banner_image && (
                <span style={{ color: "red", fontSize: "14px" }}>
                  {errors.banner_image}
                </span>
              )}
              {/* Show either user-uploaded or API banner image */}
              {filePreviews.banner_image ? (
                <div className="file-preview">
                  <img
                    src={filePreviews.banner_image}
                    alt="Banner Preview"
                  />
                  <button
                    className="cross"
                    onClick={() => handleRemoveFile("banner_image", 0)}
                  >
                    <img
                      src="https://admin.abroadbible.net/assets/images/gray-cross.svg"
                      alt=""
                    />
                  </button>
                </div>
              ) : filePreviews.api_banner_image ? (
                <div className="file-preview">
                  <img
                    src={filePreviews.api_banner_image}
                    alt="API Banner Preview"
                  />
                  <button
                    className="cross"
                    onClick={() => handleRemoveFile("api_banner_image", 0)}
                  >
                    <img
                      src="https://admin.abroadbible.net/assets/images/gray-cross.svg"
                      alt=""
                    />
                  </button>
                </div>
              ) : null}
            </div>
          </label>
        </div>
      </div>

      {/* Additional Images Field */}
      <div className="col-sm-6" ref={imagesRef}>
        <div className="upload-wrapper">
          <input
            type="file"
            id="images"
            name="images"
            className="upload-input"
            onChange={handleFileChange}
            multiple
          />
          <label htmlFor="images" className="upload-label">
            <img
              className="upload-icon"
              src={window.getPublicUrl("/assets/images/upload.svg")}
              alt=""
            />
            Images
            <div className="upload-box">
              {errors.images && (
                <span style={{ color: "red", fontSize: "14px" }}>
                  {errors.images}
                </span>
              )}
            </div>
          </label>
        </div>
      </div>

      {/* Image Previews */}
      <div className="col-sm-12 text-center">
        {/* API Images */}
        {filePreviews.api_images.map((preview, index) => (
          <div className="file-preview" key={`api-${index}`}>
            <img src={preview} alt={`API Preview ${index}`} />
            <button
              className="cross"
              onClick={() => handleRemoveFile("api_images", index)}
            >
              <img
                src="https://admin.abroadbible.net/assets/images/gray-cross.svg"
                alt=""
              />
            </button>
          </div>
        ))}
        
        {/* User-Uploaded Images */}
        {filePreviews.images.map((preview, index) => (
          <div className="file-preview" key={`user-${index}`}>
            <img src={preview} alt={`Uploaded Preview ${index}`} />
            <button
              className="cross"
              onClick={() => handleRemoveFile("images", index)}
            >
              <img
                src="https://admin.abroadbible.net/assets/images/gray-cross.svg"
                alt=""
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>
      <div className="modal-footer">
        <button className="cancel" onClick={() => setAddVenueModal(false)}>
          Cancel
        </button>
        <button className="save" onClick={handleSubmit} disabled={loader}>
          {loader && <div className="spinner-border" role="status"></div>}
          Save
        </button>
      </div>
    </div>
  );
};

export default AddVenueModal;